import { Component, OnInit, OnDestroy } from '@angular/core';
import { MessageService, ConfirmationService } from 'primeng/api';
import { GiftCardOrderSalesModel, GiftCardVirtualsModel } from "src/app/models/gifcardVirtual.model";
import { saveAs } from 'file-saver';
import { ExcelService } from 'src/app/services/excel.service';
import { AuthService } from 'src/app/services/auth.service';
import { timer } from 'rxjs';
import { Subscription } from 'rxjs';
import { TraceService } from 'src/app/services/trace.service';
import { GifcardFisicaService } from 'src/app/services/giftcardFisica.service';

@Component({
  selector: 'app-ordersales-fisica-step1-list',
  templateUrl: './ordersales-fisica-step1-list.component.html',
  styleUrls: ['./ordersales-fisica-step1-list.component.css']
})
export class OrdersalesFisicaStep1ListComponent implements OnInit, OnDestroy {

  constructor(private giftCardFisicaService: GifcardFisicaService,
    private messageService: MessageService,
    private excelService: ExcelService,
    private authService: AuthService,
    private confirmationService: ConfirmationService,
    private traceService: TraceService) { }

  private subscription: Subscription = new Subscription();
  totalOrderSales: number;
  dlgOrderSales: boolean;
  dlgEmailFails: boolean;
  dlgUpdateEmail: boolean;
  itemOrderSales;
  itemSendFails;
  selectOrderSales: GiftCardOrderSalesModel;
  datasourceTablaOrderSales: GiftCardOrderSalesModel[] = [];
  colsTablaOrderSales: any[];
  colsTablaEmailFails: any[];
  dataDetail: {};
  datasourceGiftCardVirtual: GiftCardVirtualsModel[] = [];
  loading: boolean = false;
  currentUser: string;
  dlgAnulate: boolean = false;
  dlgReject: boolean = false;
  observation: string;
  observationReject: string;

  ngOnInit() {
    this.currentUser = this.authService.getCurrentUser();
    this.createColumnsTablaGiftCardVirtual();
    this.populateTableOrderSales();
    //this.refreshData();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  refreshData() {
    this.subscription.add(this.populateTableOrderSales());
    this.subscription.add(this.subscribeToData());
  }

  subscribeToData() {
    this.subscription.add(console.log("refreshdata"));
    this.subscription.add(
      timer(60000).subscribe(() => this.refreshData())
    );
  }

  createColumnsTablaGiftCardVirtual() {
    this.colsTablaOrderSales = [
      { field: 'NRO_ORDEN_COMPRA', header: 'Nro. Ord. Compra', width: '8%', align: 'center' },
      { field: 'DESC_MODELO_GIFT_CARD', header: 'Modelo Giftcard', width: '10%', align: 'center' },
      { field: 'NRORUC_CLIENTE', header: 'RUC', width: '7%', align: 'center' },
      { field: 'RAZSOC_CLIENTE', header: 'Razón Social', width: '35%', align: 'center' },
      { field: 'IMP_ORDEN_COMPRA', header: 'Importe', width: '8%', align: 'center' },
      { field: 'CAN_ORDEN_COMPRA', header: 'Cant.', width: '6%', align: 'center' },
      { field: 'CREATIONDATE', header: 'Fecha Registro', width: '10%', align: 'center' }
    ];
  }

  populateTableOrderSales() {
    this.loading = true;
    let params = {
      "p_flag_activo": 6,
      "p_creationuser": this.currentUser
    }

    this.giftCardFisicaService.GetOrderSalesFisicaByStatusAndUser(params).subscribe(
      (response: GiftCardOrderSalesModel[]) => {
        this.datasourceTablaOrderSales = response;
        this.totalOrderSales = this.datasourceTablaOrderSales.length;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar las ordenes de compra.' });
      }
    )
  }

  onShowDlgAnulate(order: GiftCardOrderSalesModel) {
    this.itemOrderSales = order;
    this.dlgAnulate = true;
  }

  onShowDlgOrderSales(order: GiftCardOrderSalesModel) {
    this.itemOrderSales = order;
    this.dlgOrderSales = true;
  }

  onShowDlgReject(order: GiftCardOrderSalesModel) {
    this.itemOrderSales = order;
    this.observationReject = this.itemOrderSales.OBSERVACIONES;
    this.dlgReject = true;
  }

  onShowConfirmAnulate() {
    if (this.observation) {
      this.confirmationService.confirm({
        message: '¿Está seguro de anular la orden de compra?',
        accept: () => {
          this.anulateOrderSalesStatus();
          this.createOrderSalesTrace('ANULADO');
          this.dlgAnulate = false;
          this.populateTableOrderSales();
        }
      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe ingresar el motivo de la anulación en el campo observación' });
    }
  }

  createOrderSalesTrace(status: string) {
    let params = {
      "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
      "p_id_modelo_gift_card": this.itemOrderSales.ID_MODELO_GIFT_CARD,
      "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
      "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT,
      "p_type_order_sales" : this.giftCardFisicaService.TYPE_ORDER_SALES_FISICA,
      "p_action": status,
      "p_observation": this.observation,
      "p_creationuser": this.currentUser
    };
    this.traceService.CreateGiftCardOrderSalesTrace(params).subscribe(
      (response) => {
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Trace registrado correctamente.' });
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al crear el trace de la orden de compra' });
      }
    )
  }

  anulateOrderSalesStatus() {
    this.loading = true;
    let params = {
      "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
      "p_id_modelo_gift_card": this.itemOrderSales.ID_MODELO_GIFT_CARD,
      "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
      "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT,
      "p_flg_activo": 0
    }
    this.giftCardFisicaService.UpdateOrderSalesFisicaStatus(params).subscribe(
      (response) => {
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Anulación paso 1: exitoso.' });

      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al anular orden de compra.' });
      }
    )
  }

  downloadIMGModel() {
    saveAs(this.itemOrderSales.IMG_MODELO_GIFT_CARD, "modelo.jpg");
  }

  downloadIMGOrder() {
    saveAs(this.itemOrderSales.IMG_ORDEN_COMPRA, "orden.jpg");
  }

  downloadIMGCotizacion() {
    saveAs(this.itemOrderSales.IMG_COTIZACION, "cotizacion.jpg");
  }

  donwloadAdicional1() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL1, "adicional.jpg");
  }

  donwloadAdicional2() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL2, "adiciona2.jpg");
  }

  donwloadAdicional3() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL3, "adiciona3.jpg");
  }

}
